import React from 'react';
import { BookOpen } from 'lucide-react';
import { NavigationContainer } from './NavigationContainer';

export function MainMenu() {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-800 mb-3 flex items-center justify-center gap-3">
          <BookOpen className="text-blue-600" size={40} />
          Niemiecki Vocabulary
        </h1>
        <p className="text-lg text-gray-600">
          Skonfiguruj swoją sesję nauki i rozpocznij przygodę z niemieckim!
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
        <NavigationContainer />
      </div>
    </div>
  );
} 